export default {
  userRole: (state) => {
    return state.userRole;
  },
};
